import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TopBar from './TopBar';

export default function PageShell({ title, subtitle, breadcrumbs, children, activeTab = 'dashboard' }) {
  const navigate = useNavigate();

  return (
    <div className="workspace-shell">
      <aside className="workspace-sidebar">
        <div className="sidebar-brand">
          <span className="brand-mark">Q</span>
          <span className="brand-title">QuantumTrade</span>
        </div>
        <nav className="sidebar-nav">
          <Link to="/" className={`nav-button ${activeTab === 'dashboard' ? 'active' : ''}`}>Dashboard</Link>
          <Link to="/orders" className={`nav-button ${activeTab === 'orders' ? 'active' : ''}`}>Orders</Link>
          <Link to="/watchlists" className={`nav-button ${activeTab === 'watchlists' ? 'active' : ''}`}>Watchlists</Link>
          <Link to="/markets" className={`nav-button ${activeTab === 'markets' ? 'active' : ''}`}>Markets</Link>
          <Link to="/settings" className={`nav-button ${activeTab === 'settings' ? 'active' : ''}`}>Settings</Link>
          <Link to="/legal" className={`nav-button ${activeTab === 'legal' ? 'active' : ''}`}>Legal</Link>
        </nav>
        <div className="sidebar-footer">
          <button type="button" className="secondary-button small" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
      </aside>
      <main className="workspace-main">
        <TopBar title={title} subtitle={subtitle} breadcrumbs={breadcrumbs} />
        <div className="workspace-content">{children}</div>
      </main>
    </div>
  );
}
